import Vue from 'vue'
import toastr from 'toastr'

toastr.defaultClassNames = ["animated", "zoomInUp"];
toastr.defaultPosition = "toast-top-left";

Vue.prototype.$toastr = toastr;
